import { Fragment } from 'react';
import classNames from 'classnames';
import ThumbnailCarousel from '@hc/component-lib/hclib/components/molecules/carousel-thumbnail/ThumbnailCarousel';
import { PhotoDate } from 'legacy/components/PhotoDate';
import { dollarsFormatter } from 'legacy/utils/formatters';
import { isLoading } from 'legacy/utils/status';

import Loading from 'legacy/components/generic/Loading';
import PhotoPlaceholder from 'legacy/components/PhotoPlaceholder';
import { usePhotos } from 'legacy/hocs/usePhotos';
import { SubjectPhotoCard as theme } from 'legacy/css-modules';
import { ThumbnailImage } from '@hc/component-lib/hclib/components/atoms/thumbnail-image';

import { PropertyStreetViewDialog } from 'legacy/containers/property-street-view';

const SubjectPhotoCard = ({
  addressId,
  subject,
  className,
  onClick,
  activePrice
}) => {
  const { status, photos, firstPrecedingEffectiveDate } = usePhotos(addressId, {
    property: subject
  });
  const clickable = !!photos && photos.length;
  const loading = isLoading(status);
  return (
    <div
      className={classNames(theme.SubjectPhotoCard, className, {
        [theme.clickable]: clickable
      })}
      data-hc-name="map-photo-card"
      onClick={clickable ? onClick : undefined}
    >
      <Loading loading={loading}>
        {!photos || !photos.length ? (
          <PhotoPlaceholder />
        ) : (
          <Fragment>
            <div className={theme.Photo}>
              <ThumbnailCarousel
                dataHcName="subject-photo-thumbnail"
                initialIndex={firstPrecedingEffectiveDate}
              >
                {photos.map((p) => (
                  <ThumbnailImage url={p.httpUrl} key={p.httpUrl}>
                    {p.imageDate && (
                      <PhotoDate
                        date={p.imageDate}
                        className={theme.EffectiveDateWarning}
                      />
                    )}
                  </ThumbnailImage>
                ))}
              </ThumbnailCarousel>
            </div>
            {activePrice && (
              <div
                className={theme.Info}
                data-hc-name="map-photo-subject-active-price"
              >
                <span className={theme.AccentText}>For Sale</span>
                {dollarsFormatter(activePrice)}
              </div>
            )}
            <PropertyStreetViewDialog
              property={subject}
              classNameTrigger={theme.StreetViewIcon}
            />
          </Fragment>
        )}
      </Loading>
    </div>
  );
};

export default SubjectPhotoCard;
